<template>
  <div class="main">


   <v-flex xs12 class="mb-4 pb-4">
      <v-toolbar fixed dense color="white">
      <v-toolbar-title class="grey--text text--darken-4 text-xs-center" style="font-size: 1.6rem;">Stage1 : Page Reload Issue</v-toolbar-title>
     <!--
        <v-btn icon light to="/">
          <v-icon color="grey darken-2">arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 text-xs-center tklogo">T K</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn active-class icon to="/">
          <v-tooltip color="blue" nudge-left="30px" bottom>
            <v-icon slot="activator" color="black" dark>fa fa-home</v-icon>
            <span>Back to Home</span>
          </v-tooltip>
        </v-btn>
        <v-btn flat round icon :href="facebook" target="_blank">
          <v-tooltip color="blue" nudge-left="30px" bottom>
          <v-icon slot="activator" color="black" medium>fab fa-facebook-square</v-icon>
            <span>Visit Us on Facebook</span>
          </v-tooltip>
        </v-btn>
        -->
      </v-toolbar>
    </v-flex>

    <v-container grid-list-lg fluid>
      <v-layout wrap justify-center>
        <v-flex>
          <v-card class="pa-2">
            <v-icon class="profilebio pb-1 pr-1" size=".8rem" color="blue">fa fa-circle</v-icon><b>Issue Recreation:</b><br>
            1. Open up Chrome Dev Tools -> Console (or whatever browser you are using, open its development tools and go to its console (f12)).<br>
            2. Next, click on any one of the cards below. This will load the route, stage2 (which is Stage2.vue). At stage2 will be the full description of the issue and instructions on how to recreate.<br>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-container fluid grid-list-md>
      <v-layout wrap>
        <v-flex offset-sm3 xs6 hidden-sm-and-down>
           <v-text-field
             clearable
             hint="Enter the cat name for your search (max 50 characters). Results will display below."
             v-model="tksearch"
             class="v-card-border pb-0 mb-2 pl-1 pr-1"
             label="Search By Name"
             color="blue"
             counter="50"
             maxlength="50"
             :rules="[rules.counter]"
           >
             <v-fade-transition slot="append">
               <v-img class="mb-2 pa-0" width="85" height="28" :src="require(`@/img/${tklogo}`)"></v-img>
             </v-fade-transition>
           </v-text-field>
         </v-flex>
         <v-flex xs12 hidden-md-and-up>
           <v-text-field
             clearable
             hint="Enter the cat name for your search (max 50 characters). Results will display below."
             append-icon="search"
             v-model="tksearch"
             class="v-card-border pb-0 mb-2 pl-1 pr-1"
             label="Search By Name"
             color="blue"
             counter="50"
             maxlength="50"
             :rules="[rules.counter]"
           >
             <v-fade-transition slot="append">
               <v-img class="mb-2 pa-0" width="85" height="28" :src="require(`@/img/${tklogo}`)"></v-img>
             </v-fade-transition>
           </v-text-field>
         </v-flex>
      </v-layout>

      <v-layout wrap justify-center>
          <v-flex xs12 sm6 md4 xl3 v-for="(tkcat, index) in tkavatar" :key="index">
              <v-card color="blue lighten-3 mb-2" class="v-card-border black--text" hover elevation-24>
                <v-layout>
                  <router-link class="rtlnk" :to="{name: 'Stage2', params: {tkid: tkcat.tkid} }">
                    <v-flex xs3 class="pl-3 pr-0 ma-0">
                      <v-avatar size="110"><v-img :src="require(`@/img/${tkcat.avatar}`)"></v-img></v-avatar>
                      <!-- <v-img height="110" width="110" :src="require(`@/img/${tkcat.avatar}`)"></v-img> -->
                    </v-flex>
                  </router-link>
                  <v-flex xs9>
                    <v-card-title primary-title class="pa-0 ma-0 pl-5">
                    <v-divider vertical inset></v-divider>
                      <div class="pl-3">
                        <router-link class="rtlnk" :to="{name: 'Stage2', params: {tkid: tkcat.tkid} }">
                          <div class="thetkname" v-text="tkcat.tkname"></div>
                          <div class="pl-1 ma-0" style="color: black;" v-text="tkcat.tkinfo"></div>
                        </router-link>
                        <v-card-actions class="pa-0 ma-0">
                          <v-btn icon>
                            <v-tooltip color="blue" nudge-down="10px" nudge-left="50px" bottom>
                              <v-icon slot="activator" color="black">favorite</v-icon>
                              <span>Add <span class="fluppercase">{{ tkcat.tkname }}</span> as a favorite. This feature is soon to come.</span>
                            </v-tooltip>
                          </v-btn>
                          <v-btn icon>
                            <v-tooltip color="blue" nudge-down="10px" nudge-left="65px" bottom>
                              <v-icon slot="activator" color="black">bookmark</v-icon>
                              <span>Bookmark <span class="fluppercase">{{ tkcat.tkname }}</span>. This feature is soon to come.</span>
                            </v-tooltip>
                          </v-btn>
                          <v-btn icon>
                            <v-tooltip color="blue" nudge-down="10px" nudge-left="110px" bottom>
                              <v-icon slot="activator" color="black">fab fa-facebook-square</v-icon>
                              <span>Post <span class="fluppercase">{{ tkcat.tkname }}</span> on Facebook. This feature is soon to come.</span>
                            </v-tooltip>
                          </v-btn>
                        </v-card-actions>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
              </v-card>
          </v-flex>
      </v-layout>
    </v-container>

    <!-- TESTING GETTING ID, TKNAME, AND AVATAR FROM STORE -->
    <!-- <v-btn @click="getids">Click to get IDs</v-btn> -->

    <v-container>
      <v-layout class="footer">
        <footer-view></footer-view>
      </v-layout>
    </v-container>

  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import Stage2 from "./Stage2";
import FooterView from "./FooterView";
import TkHeaderView from "./TkHeaderView";

export default {
  components: {
    Stage2,
    FooterView,
    TkHeaderView
  },
  data: () => ({
    title: 'TK Logo',
    facebook: 'https://www.facebook.com/timmyskittys1',
    tklogo: 'sebastian_logo_layer_at_1440x1105.png',
    tksearch: '',
    tkfilterCategory: 'all',
    rules: {
      counter: value => value.length <= 50 || 'Max 50 characters',
    },
    headers: [
        { text: '', value: '' },
        { text: '', value: '' },
        { text: '', value: '' },
      ],
  }),
  created() {
    this.$store.dispatch('fetchTkData')
  },
  computed: {
    ...mapGetters([
      'getAllData'
    ]),
    tkavatar() {
      // console.log("tkavatar: " + JSON.stringify(this.getAllData[1]))  // For TESTING
      let alltkdata = this.getAllData
      if (this.tksearch) {
      	alltkdata = alltkdata.filter((tkcat) => {
        	return tkcat.tkname.indexOf(this.tksearch.toLowerCase()) !== -1
        })
      }
      return alltkdata
    },
  },
};

</script>

<style scoped>
.main {
  /* background-image: url("../img/white_silk_bkgrnd_1024x640.jpg"); */
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x990.jpg"); */
  /* background-image: url("../img/white_wrinkled_silk_blue_1440x1190.jpg"); */
  /* background-color: #edf0fd; */
  /* background-color: #fefefa; */
  background-color: #f8f8ff;
  color: #1d2731;
  background-size: cover;
  width: 100%;
  height: 100%;
}
.toolbar {
  background-color: #f8f8ff;
}
.v-card-border {
  border-radius: 2px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 1);
}
.thetkname {
  text-transform: capitalize;
  color: black;
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2.6rem;
}
.tklogo {
  font-family: "Great Vibes", Arial, Helvetica, sans-serif;
  font-size: 2rem;
  font-weight: bold;
 }
.fluppercase {
  text-transform: capitalize;
}
.rtlnk {
  list-style-type: none;
  text-decoration: none;
}
.footer {
  margin-top: 10px;
}
@media screen and (max-width: 599px) {
  .footer {
    margin-top: 60px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Stage1.vue